import React, { useEffect, useState } from "react";
import Image from "next/image";
import { Button } from "components/Button";
import { useRouter } from "next/router";
import Link from "next/link";

interface ContactCtaProps {
  className?: string;
}

const ContactCta = ({ className }: ContactCtaProps) => {
  const router = useRouter();
  const [imageSrc, setImageSrc] = useState("/contact-img.png");
  const isGolf = router.asPath === "/services/golf-tournament-management/";

  useEffect(() => {
    // Check if we're on the golf tournament management page
    if (router.asPath === "/services/golf-tournament-management/") {
      setImageSrc("/images/golf-contact-img.jpg");
    } else {
      setImageSrc("/contact-img.png");
    }
  }, [router.asPath]);

  return (
    <>
      {isGolf && (
        <div className="mx-auto max-w-[1500px] px-6 lg:px-24 my-10">
          <div className="mb-10 max-w-[340px] font-serif italic text-[2.2rem] leading-none text-left md:text-left">
            <span className="uppercase font-semibold">Package</span>
            <br />
            Add On Options:
          </div>
          <div className="flex flex-col md:flex-row gap-20 xl:gap-40">
            <div className="flex-1 text-lg flex flex-col gap-4 items-start">
              <h2 className="font-semibold font-serif capitalize text-3xl italic">
                Sponsorship Support Add-on Package
              </h2>
              We offer a toolkit designed to help you confidently pitch,
              package, and deliver for sponsors, with final pricing based on
              your selected services and add-ons. This includes:
              <ul className="list-disc pl-8">
                <li>
                  Sponsor activation ideation and creation of sponsorship levels
                  and benefits
                </li>
                <li>Branded sponsorship sales materials </li>
                <li>Sponsor tracking templates</li>
                <li>Proof-of-performance photos and recap</li>
                <li>Post-event sponsor-facing reporting</li>
              </ul>
              <Link
                href="/contact-us"
                className="rounded-full border border-black text-black py-1 px-10 inline-block hover:bg-primary transition-all duration-300"
              >
                Contact Us
              </Link>
            </div>
            <img
              src="/images/224b48942272d343899a41bf138a1da622ff901e.png"
              alt=""
              className="w-full h-full aspect-square max-w-[350px] max-h-[350px] rounded-full"
            />
          </div>

          <div className="flex flex-col md:flex-row-reverse gap-20 xl:gap-40 mt-24">
            <div className="flex-1 text-lg flex flex-col gap-4 items-start">
              <h2 className="font-semibold font-serif capitalize text-3xl italic">
                Silent Auction Add-On Package
              </h2>
              We provide a polished, high-impact auction setup that requires
              minimal effort from your team, with final pricing based on your
              selected services and add-on options. This includes:
              <ul className="list-disc pl-8">
                <li>Setup and management of auction platform</li>
                <li>
                  Cataloging of auction items (client- or sponsor-provided)
                </li>
                <li>Item image sourcing and compelling package descriptions</li>
                <li>Social media-ready graphics to promote the auction</li>
                <li>Creation of printed item display sheets</li>
                <li>
                  Professional, visually appealing auction display at the event
                </li>
                <li>Staffed auction check-out and assistance with pack-up</li>
                <li>
                  Please note: Post-event item fulfillment is handled by you or
                  your team.
                </li>
              </ul>
              <Link
                href="/contact-us"
                className="rounded-full border border-black text-black py-1 px-10 inline-block hover:bg-primary transition-all duration-300"
              >
                Learn More
              </Link>
            </div>
            <img
              src="/images/1899a64481ca620e27f6409c0c9e1bea12ae2466.png"
              alt=""
              className="w-full h-full aspect-square max-w-[350px] max-h-[350px] object-cover rounded-full"
            />
          </div>
        </div>
      )}
      <section className={`${className ? className : ""}`}>
        <div className="mx-auto flex max-w-[1500px] flex-col md:flex-row items-center pt-10 pb-10 md:pb-0 md:py-10">
          <div className="w-full md:w-1/2 lg:w-2/5 px-10 lg:px-20 py-0 md:py-10">
            <div className="relative">
              <h2
                className={`mb-10 max-w-[340px] font-serif text-[2.5rem] font-semibold leading-none text-center md:text-left`}
              >
                READY <span className={`font-normal italic`}>for the</span>{" "}
                NINTH FLOOR{" "}
                <span className={`font-normal italic`}>experience?</span>
              </h2>
              <Button
                type={`primary`}
                className={`flex w-fit flex-row items-center lg:border-[1px] lg:border-black text-[1rem] lg:py-2 lg:px-6 lg:hover:bg-primary lg:hover:text-black mx-auto md:mx-0`}
                href={`/contact-us`}
              >
                <Image
                  src={`https://cms.ninthfloorevents.com/wp-content/uploads/2023/09/phone_ico.svg`}
                  alt={`Contact Us`}
                  width={22}
                  height={22}
                  className={`mr-4 w-4`}
                />
                Contact Us
              </Button>
            </div>
          </div>
          <div className="hidden md:block w-1/2 lg:w-3/5 rounded-l-full border-[1px] border-r-0 border-black p-10 pr-0">
            <div className="relative h-full min-h-[25rem] w-full overflow-hidden rounded-l-full">
              <Image
                src={imageSrc}
                alt={`Contact Us`}
                fill
                className={`object-cover object-center`}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactCta;
